import { CreditScore, VehiclePlan } from '../types';
import { Form } from 'react-router';
import { PDPErrors } from '../types/pdp-action';

import CreditAgeChangeDrawerDialog from './credit-age-change-drawer-dialog';
import HowMileageWorksDrawerDialog from './how-mileage-works-drawer-dialog';
import MileagePackageRadioGroup from './mileage-package-radio-group';
import Spacer from '@/common/components/spacer';
import { LoaderButton } from '@/common/components/loader-button';
import usePDPSelectPlanSubmit from '../hooks/use-pdp-select-plan-submit';
import { AgeRange } from '../types/age-range';

interface PDPSelectMonthlyPlanProps {
  vehiclePlans: VehiclePlan[];
  mostPopularPlanMileageAmount?: string;
  isOrderable: boolean;
  errors?: PDPErrors;
  // CreditAgeChangeDrawerDialog props
  creditModalOpen: boolean;
  handleCloseCreditModal: () => void;
  handleOpenCreditModal: () => void;
  // Credit
  creditScores: CreditScore[];
  ageRanges?: AgeRange[];
  selectedIsOver25: boolean;
  selectedCreditScoreId?: string;
  selectedAgeRangeId?: string;
  selectedMileagePlan?: number;
  fullstoryPlanEventDelegate: () => void;
}

export default function PDPSelectMonthlyPlan({
  vehiclePlans,
  mostPopularPlanMileageAmount,
  isOrderable,
  errors,
  // CreditAgeChangeDrawerDialog props
  creditModalOpen,
  handleCloseCreditModal,
  handleOpenCreditModal,
  // Credit
  creditScores,
  ageRanges,
  selectedIsOver25,
  selectedCreditScoreId,
  selectedAgeRangeId,
  selectedMileagePlan,
  fullstoryPlanEventDelegate,
}: PDPSelectMonthlyPlanProps) {
  const { handleSelectPlan, selectedPlanId } = usePDPSelectPlanSubmit(
    vehiclePlans,
    selectedMileagePlan,
    fullstoryPlanEventDelegate
  );

  return (
    <div className="px-8 md:px-7">
      <div className="flex flex-row items-center gap-[8px]">
        <h3 className="mt-[2px]">Select your monthly plan</h3>
        <HowMileageWorksDrawerDialog vehiclePlans={vehiclePlans} />
      </div>
      <Spacer variant="height4" />
      <p className="body2">Protection included. Change plans anytime.</p>
      <Spacer variant="height24" />
      <Form method="post" className="flex flex-col justify-center">
        <MileagePackageRadioGroup
          vehiclePlans={vehiclePlans}
          selectedPlanId={selectedPlanId || ''}
          mostPopularPlanMileageAmount={mostPopularPlanMileageAmount}
          onValueChange={(event) => handleSelectPlan(event)}
          disabled={!isOrderable}
          error={errors?.plan}
        />
        <Spacer variant="height24" />
        <CreditAgeChangeDrawerDialog
          // DrawerDialog
          open={creditModalOpen}
          handleOpen={handleOpenCreditModal}
          handleClose={handleCloseCreditModal}
          // Credit
          selectedCreditScoreId={selectedCreditScoreId}
          selectedIsOver25={selectedIsOver25}
          creditScores={creditScores}
          ageRanges={ageRanges}
          selectedAgeRangeId={selectedAgeRangeId}
        />
        <Spacer variant="height24" />
        <LoaderButton
          type="submit"
          name="intent"
          value="plan"
          className="w-full"
          disabled={!isOrderable}
        >
          Continue to schedule
        </LoaderButton>
      </Form>
    </div>
  );
}
